'use client'

import { InstructionSize } from '@/app/[locale]/product/[slug]/_components/product-info-sizes/instructions-size'
import { useTranslations } from 'next-intl'
import { useProductDetailSafe } from '../../context/product-detail-context'
import { useProductDetailStore } from '../../hooks/use-product-detail-store'
import { ProductInfoSizeItem } from './product-info-size-item'

type Props = {
  sizeChart: string
}

export const ProductInfoSizes: React.FC<Props> = ({ sizeChart }) => {
  const { sizeSelected, setSizeSelected, sizeOptions } = useProductDetailSafe()
  const { isDisableSize } = useProductDetailStore()
  const t = useTranslations('title')
  if (
    !sizeOptions?.length ||
    (sizeOptions.length === 1 && sizeOptions[0] === '')
  ) {
    return null
  }

  return (
    <div>
      <div className='mb-2 flex items-baseline justify-between lg:py-0'>
        <span className='font-sans text-base leading-5 text-neutral-900 max-lg:hidden'>
          {t('size')}:{' '}
          <p className='inline text-neutral-600'> {sizeSelected}</p>
        </span>
        <InstructionSize sizeChart={sizeChart} />
      </div>

      <ul className='flex flex-wrap gap-3 lg:gap-4 lg:gap-y-3'>
        {sizeOptions.map((sizeOption, index) => (
          <ProductInfoSizeItem
            key={index}
            isActive={sizeSelected === sizeOption}
            onClick={() =>
              !isDisableSize(sizeOption) && setSizeSelected(sizeOption)
            }
            title={sizeOption}
            isDisabled={isDisableSize(sizeOption)}
          />
        ))}
      </ul>
    </div>
  )
}
